import React, { useEffect, useState } from "react";
import Topbar from "../Components/Structure/Topbar";
import { Grid, Typography, TextField } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import BackButton from "../Components/Structure/BackButton";
import { useTranslation } from "react-i18next";
import SettingsModal from "../Components/Structure/SettingsModal";

function Settings() {
  // 1) Data
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const { t } = useTranslation();
  const LoginSettings = useSelector((state) => state.LoginSettings.value);
  const Account = useSelector((state) => state.Account.value);
  const [serverName, setserverName] = useState("");
  const [serverID, setserverID] = useState("");
  const [buttons, setbuttons] = useState([]);
  const [vehicles, setvehicles] = useState([]);
  const [extraButtons, setextraButtons] = useState([]);
  const [prices, setprices] = useState("");
  const [banner, setbanner] = useState("");
  const [comments, setcomments] = useState("");
  const [customMapKey, setcustomMapKey] = useState(false);
  const [seconds, setseconds] = useState("");
  const [mapType, setmapType] = useState("");
  const [key, setkey] = useState("");
  const [showModal, setshowModal] = useState(true);
  const [PosCode, setPosCode] = useState("");
  const [HotelCode, setHotelCode] = useState("");

  // 2) UseEffects

  useEffect(() => {
    setserverName(ApplicationSettings.server_name);
    setserverID(ApplicationSettings.server_id);
    setbuttons(ApplicationSettings.ButtonsArray);
    setextraButtons(ApplicationSettings.Extra_Destinations_Array);
    setvehicles(ApplicationSettings.CarTypesArray);
    setprices(ApplicationSettings.ShowPrices);
    setbanner(ApplicationSettings.ShowBanner);
    setcomments(ApplicationSettings.Show_Call_Comments);
    setcustomMapKey(ApplicationSettings.Use_Custom_Map_Key);
    setseconds(ApplicationSettings.Refresh_Calls_Seconds);
    setmapType(ApplicationSettings.Use_Here_Maps);
    setPosCode(ApplicationSettings.Code_for_POS);
    setHotelCode(ApplicationSettings.Car_Type_Code_To_Show_Hotel);

    if (ApplicationSettings.Use_Custom_Map_Key) {
      setkey(ApplicationSettings.Map_Key);
    } else {
      setkey(Account.google_key);
    }

    return;
  }, []);

  // 3) Functions

  return (
    <>
      <Topbar page="Settings" />

      {/* Header */}
      <div className="text-center mt-3">
        <p className=" text-3xl  Primary_Main_Text">{t("ΡΥΘΜΙΣΕΙΣ")}</p>
      </div>

      {/* Form */}
      {showModal ? (
        <>
          <SettingsModal showModal={showModal} setshowModal={setshowModal} />
        </>
      ) : (
        <>
          {/* Config Explain */}
          {/* <div className="w-full max-w-3xl m-auto p-3 mt-2">
            <p className="text-lg font-bold">
              ΕΞΗΓΗΣΗ ΓΙΑ ΤΗΝ ΛΕΙΤΟΥΡΓΙΑ ΤΗΣ ΕΦΑΡΜΟΓΗΣ
            </p>
            <p>
              Για να στηθεί η εφαρμογή, πρέπει να δώσουμε ανάλογες τιμές στο
              config.json του εκάστοτε server. Το config βρίσκεται στον φάκελο
              που είναι τα αρχεία της εφαρμογής.
            </p>
            <p>Στα πεδία "server_name" και "server_id" πρέπει να μπουν τα στοιχεία του server. Προσοχή, έχει σημασία ο τίτλος </p>
          </div> */}
          <form className="w-full max-w-3xl m-auto p-3 mt-2">
            {/* Server settings */}{" "}
            <p className="text-lg font-bold py-2">{t("ΡΥΘΜΙΣΕΙΣ_SERVER")}</p>
            <div className="pt-2">
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="grid-first-name"
                  >
                    Server
                  </label>
                  <input
                    value={serverName}
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="grid-first-name"
                    type="text"
                    placeholder="Iqtaxi"
                    disabled="true"
                  />
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="sid"
                  >
                    Server ID
                  </label>
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="sid"
                    type="text"
                    placeholder="20"
                    value={serverID}
                    disabled="true"
                  />
                </div>
              </div>
            </div>
            {/* Buttons  */}
            <p className="text-lg font-bold py-2">{"ΡΥΘΜΙΣΕΙΣ_BUTTON"}</p>
            <div className="">
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="grid-password"
                  >
                    {t("ΛΙΣΤΑ_ΔΙΕΥΘΥΝΣΕΩΝ_(ONOMA-TIMH)")}
                  </label>
                  <Grid container spacing={2}>
                    {buttons.map((e) => {
                      return (
                        <>
                          <Grid item xs={6}>
                            <input
                              value={e.name}
                              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              id="grid-password"
                              type="text"
                              placeholder="Name"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <input
                              value={e.price}
                              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              id="grid-password"
                              type="text"
                              placeholder="Name"
                            />
                          </Grid>
                        </>
                      );
                    })}
                  </Grid>
                </div>
              </div>
            </div>
            {/*Extra Buttons  */}
            <div className="">
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3">
                  <label
                    className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                    for="grid-password"
                  >
                    {t("EXTRA_ΛΙΣΤΑ_ΔΙΕΥΘΥΝΣΕΩΝ_(ONOMA_-_TIMH)")}
                  </label>
                  <Grid container spacing={2}>
                    {extraButtons.map((e) => {
                      return (
                        <>
                          <Grid item xs={6}>
                            <input
                              value={e.name}
                              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              id="grid-password"
                              type="text"
                              placeholder="Name"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <input
                              value={e.price}
                              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              id="grid-password"
                              type="text"
                              placeholder="Name"
                            />
                          </Grid>
                        </>
                      );
                    })}
                  </Grid>
                </div>
              </div>
            </div>
            {/* Vehicles  */}
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-password"
                >
                  {t("ΛΙΣΤΑ_ΟΧΗΜΑΤΩΝ_ΡΑΝΤΕΒΟΥ_(ΤΥΠΟΣ_-_ΚΩΔΙΚΟΣ)")}
                </label>
                <Grid container spacing={2}>
                  {vehicles.map((e) => {
                    return (
                      <>
                        <Grid item xs={6}>
                          <input
                            value={e.name}
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="grid-password"
                            type="text"
                            placeholder="Name"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <input
                            value={e.code}
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="grid-password"
                            type="text"
                            placeholder="Name"
                          />
                        </Grid>
                      </>
                    );
                  })}
                </Grid>
              </div>
            </div>
            {/* True or False Otpions */}
            <p className="text-lg font-bold py-2">{t("AΛΛΕΣ_ΡΥΘΜΙΣΕΙΣ")}</p>
            <div className="flex flex-wrap -mx-3 mb-2">
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("Εμφανιση_Τιμων")}
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                    value={prices ? "NAI" : "OXI"}
                  >
                    <option>{t("YES")}</option>
                    <option>{t("NO")}</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("Εμφανιση_Μπανερ")}
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                    value={banner ? t("YES") : t("NO")}
                  >
                    <option>{t("YES")}</option>
                    <option>{t("NO")}</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("ΣΧΟΛΙΑ_ΣΤΙΣ_ΚΛΗΣΕΙΣ")}
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                    value={comments ? t("YES") : t("NO")}
                  >
                    <option>{t("YES")}</option>
                    <option>{t("NO")}</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            {/* Options */}
            <div className="flex flex-wrap -mx-3 mb-2 mt-2 pb-20">
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("ΚΛΕΙΔΙ_ΓΙΑ_ΧΑΡΤH_ΑΠΟ_CONFIG")}
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                  >
                    <option>{customMapKey ? "NAI" : "OXI"}</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("ΤΥΠΟΣ_ΧΑΡΤΗ")}
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                  >
                    <option>{mapType ? "Here Maps" : "Google Maps"}</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("ΔΕΥΤΕΡΟΛΕΠΤΑ_ΑΝΑΝΕΩΣΗΣ_ΚΛΗΣΕΩΝ")}
                </label>
                <div className="relative">
                  <select
                    className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    id="grid-state"
                  >
                    <option>{seconds}</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <svg
                      className="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-full px-3 mt-5">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("ΚΛΕΙΔΙ_ΧΑΡΤH")}
                </label>
                <input
                  value={"**************" + key.substr(key.length - 10)}
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="grid-password"
                  type="text"
                  placeholder="Key"
                />
              </div>
              <div className="w-full px-3 md:w-1/2 mt-5">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("POS_CODE")}
                </label>
                <input
                  value={PosCode}
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="grid-password"
                  type="text"
                  placeholder="Key"
                />
              </div>
              <div className="w-full px-3 md:w-1/2 mt-5">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  for="grid-state"
                >
                  {t("HOTEL_CODE")}
                </label>
                <input
                  value={HotelCode}
                  className="appearance-none  block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="grid-password"
                  type="text"
                  placeholder="Key"
                />
              </div>
            </div>
          </form>{" "}
        </>
      )}

      {/* Back Button */}
      <div className="block sm:hidden">
        <BackButton />
      </div>
    </>
  );
}

export default Settings;
